import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nexon_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminApi = axios.create({ baseURL: API_BASE });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nexon_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
